import "./PageSizeSelector.css"

export default function PageSizeSelector({
    value,
    onChange,
    options = [10, 25, 50, 100, 500,1000],
    label = "Show",
    suffix = "records per page",
    id = "pageSize",
  }) {
    return (
      <div className="pageSizeSelector">
        <label htmlFor={id}>{label}</label>
        <select
          id={id}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
        >
          {options.map((n) => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>
        {suffix && <span>{suffix}</span>}
      </div>
    );
  }